import { faMagnifyingGlass as Search } from '@fortawesome/free-solid-svg-icons';
import {
    faTwitter as Twitter,
    faFacebookF as Facebook,
    faInstagram as Instagram,
    faPinterestP as Pinterest, 
    faTiktok as TikTok,
} from '@fortawesome/free-brands-svg-icons';
import { LogoVerdeValleMain, EspFlag, WhereToBuy } from '../assets/images';

export const navigation = {
    list: [
        { text: 'ABOUT US', path: 'about-us' },
        { text: 'PRODUCTS', path: 'products' },
        { text: 'BEANS, AS A SUPERFOOD', path: 'beans-a-superfood' },
        { text: 'RECIPES', path: 'recipes' },
        { text: 'NEWS', path: 'news' },
    ],
    isadoraLogo: {
        src: LogoVerdeValleMain,
        path: '/',
        alt: 'Isadora',
    },
    socialMedia: [
        {
            icon: Facebook,
            label: 'Facebook',
            link: 'https://www.facebook.com/IsadoraFoods',
        },
        {
            icon: Instagram,
            label: 'Instagram',
            link: 'https://www.instagram.com/isadorafoods',
        },
        {
            icon: TikTok,
            label: 'TikTok',
            link: 'https://www.tiktok.com/@isadorafoods',
        },
    ],
    shareMedia: [
        {
            icon: Facebook,
            label: 'Facebook',
        },
        {
            icon: Twitter,
            label: 'Twitter',
        },
        {
            icon: TikTok,
            label: 'TikTok',
        },
    ],
    language: {
        text: 'ES',
        src: EspFlag,
        link: 'https://www.isadoramexico.com',
        alt: 'Spanish Language',
    },
    search: {
        icon: Search,
        label: 'Search',
    },
    cart: {
        text: 'WHERE TO BUY',
        path: 'where-to-buy',
        icon: WhereToBuy,
        alt: 'Cart',
    },
};
